// Objetivo_Mensual_Screen.jsx
import React, { useState, useEffect } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import Filtro_ObjetivoMensual from "./Filtro_ObjetivoMensual";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ChartObjetivoMensual from "./Chart_Objetivo_Mensual";

const Objetivo_Mensual_Screen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);

  const onHome = () => {
    history.push("/Creditoycobranza/Main");
  };

  const onExecute = (ejercicio) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`ResumenCarteraMensual/Obtener?ejercicio=${Number(ejercicio)}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  useEffect(() => {
    // Example execution to initialize chart
    onExecute(new Date().getFullYear());
  }, []);

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 

  return (
    <PlantillaScreen
      titulo={"RESUMEN DE SALDOS DE CARTERA"}
      className_main={1}
      className={"reporte-recuperacion-cartera"}
    >
      <div className="resumen-saldos-cartera">
        <LoaderScreen loader={loader} />
        <div className="resumen-saldos-cartera-header">
          <Filtro_ObjetivoMensual onExecute={onExecute} />
        </div>
        {/* <div className="resumen-saldos-cartera-chart">
          <ChartObjetivoMensual data={data} />
        </div> */}
        <div className="resumen-saldos-cartera-table scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th rowSpan={2}>Periodo</th>
                <th colSpan={3}>Operación</th>
                <th colSpan={3}>Revolvente</th>
                <th rowSpan={2}>Total Cartera</th>
                {/* <th rowSpan={2}>Total Vencido</th>
                <th rowSpan={2}>Total por Vencer</th>
                <th rowSpan={2}>Total Objetivo</th>
                <th rowSpan={2}>Vencido</th>
                <th rowSpan={2}>Por Vencer</th> */}
              </tr>
              <tr>
                <th>Vencido</th>
                <th>Por Vencer</th>
                <th>Activa</th>
                <th>Vencido</th>
                <th>Por Vencer</th>
                <th>Activa</th>
              </tr> 
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.mes}>
                  <td>{capitalizeWords(item.mes)}</td>
                  <td className="bl">{FormatMoney(item.o_vencido, 0)}</td>
                  <td>{FormatMoney(item.o_porvencer, 0)}</td>
                  <td>{FormatMoney(item.o_activa, 0)}</td>

                  <td className="bl">{FormatMoney(item.r_vencido, 0)}</td>
                  <td>{FormatMoney(item.r_porvencer, 0)}</td>
                  <td>{FormatMoney(item.r_activa, 0)}</td>

                  <td className="bl">{FormatMoney(item.total_cartera, 0)}</td>
                  {/* <td className="bl">{FormatMoney(item.total_vencido, 0)}</td>
                  <td>{FormatMoney(item.total_porvencer, 0)}</td>
                  <td>{FormatMoney(item.total_recuperar, 0)}</td>
                  <td className="ta-center">
                    {FormatMoney(item.por_vencido, 0)} %
                  </td>
                  <td className="ta-center">
                    {FormatMoney(item.por_vencer, 0)} %
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </PlantillaScreen>
  );
};

export default Objetivo_Mensual_Screen;
